<script>
export default {
  name: "aside-tasks-svg"
}
</script>

<template>
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 2.75C18.8672 2.75 20 3.88281 20 5.25V15.25C20 16.6562 18.8672 17.75 17.5 17.75H2.5C1.09375 17.75 0 16.6562 0 15.25V2.75C0 1.38281 1.09375 0.25 2.5 0.25H7.07031C7.73438 0.25 8.35938 0.523438 8.82812 0.992188L10.7422 2.75H17.5ZM18.125 15.25V5.25C18.125 4.9375 17.8125 4.625 17.5 4.625H10L7.5 2.32031C7.38281 2.20312 7.22656 2.125 7.07031 2.125H2.5C2.14844 2.125 1.875 2.4375 1.875 2.75V15.25C1.875 15.6016 2.14844 15.875 2.5 15.875H17.5C17.8125 15.875 18.125 15.6016 18.125 15.25ZM12.4609 9.58594C12.8125 9.23438 13.3984 9.23438 13.75 9.625C14.1406 9.97656 14.1406 10.5625 13.75 10.9141L10.625 14.0391C10.4688 14.2344 10.2344 14.3125 10 14.3125C9.72656 14.3125 9.49219 14.2344 9.29688 14.0391L6.17188 10.9141C5.78125 10.5625 5.78125 9.97656 6.17188 9.58594C6.52344 9.23438 7.10938 9.23438 7.5 9.58594L9.0625 11.1484V7.125C9.0625 6.61719 9.45312 6.1875 10 6.1875C10.5078 6.1875 10.9375 6.61719 10.9375 7.125V11.1484L12.4609 9.58594Z" fill="#6C757D"/>
  </svg>
</template>

<style scoped>

</style>
